module.exports = __webpack_public_path__ + "static/media/football-helmet.7cc9409e.svg";